export const layoutConstants = {
  LAYOUT_SCROLLED_TO_BOTTOM: "LAYOUT_SCROLLED_TO_BOTTOM",
};
